import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "catalog-list-hide-blurbs"

// Compact the membership list while reordering. Lives outside the turbo-frame
// so Hide blurbs survives Up/Down replacements.
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.#apply(this.#stored())
  }

  toggle() {
    this.#apply(!this.element.classList.contains("is-compact"))
  }

  #apply(compact) {
    this.element.classList.toggle("is-compact", compact)
    try {
      sessionStorage.setItem(STORAGE_KEY, compact ? "1" : "0")
    } catch (_error) {
      // Private mode / blocked storage — still toggle for this page view.
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = compact ? "Show blurbs" : "Hide blurbs"
      this.buttonTarget.setAttribute("aria-pressed", compact ? "true" : "false")
    }
  }

  #stored() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1"
    } catch (_error) {
      return false
    }
  }
}
